const testimonials = [
  {
    name: "Michael D.",
    location: "Jensen Beach, FL",
    rating: 5,
    text: "I run a charter boat out of the St. Lucie Inlet and had a Bahamas Wahoo Championship tournament coming up in nine days. Pulled my passport and it had expired two months ago. Fast Passport Center got my renewal processed and back in five business days. Made the tournament, placed second, and didn't miss a single charter booking. These guys understand fishing deadlines.",
    service: "Emergency Passport Renewal",
  },
  {
    name: "Patricia & Robert H.",
    location: "Hutchinson Island, FL",
    rating: 5,
    text: "We're snowbirds with a condo on Hutchinson Island — summers in New York, winters here. We booked a Caribbean cruise for our 50th anniversary and discovered both our passports had expired during our two-year pandemic travel hiatus. Fast Passport Center handled both renewals simultaneously, with daily updates so we never worried. We made the cruise with a week to spare and celebrated in St. Thomas.",
    service: "Passport Renewal",
  },
  {
    name: "Sarah L.",
    location: "Jensen Beach, FL",
    rating: 5,
    text: "My son got accepted into a summer marine biology program in the Bahamas through his school — three weeks before departure. He needed his first passport. I had no idea where to start. Fast Passport Center walked me through the entire child passport process, told me exactly which clerk to visit in Stuart, and handled everything after the acceptance step. His passport arrived in four business days. He's now studying coral reef ecology in Bimini.",
    service: "Child Passport",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function JensenBeachTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Jensen Beach Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Jensen Beach anglers, Hutchinson Island residents, and Treasure Coast families who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}